import BaseAPI from '../api'
const path = 'positions'
export interface PositionInterface {
    idPosition?: number
    positionName?: string
    positionStatus?: string
    page?: number;
    limit?: number;
    keyword?: string;
}

export default class PositionApi extends BaseAPI {

    static getPositions(props: PositionInterface): Promise<any> {
        return this.api.get(`${path}`, { params: { ...props } })
            .then((res) => res)
    }
    static postPosition(props: PositionInterface): Promise<any> {
        return this.api.post(`${path}`, { ...props }, {})
            .then((res) => res)
    }
    static patchPosition(idPosition: number, props: PositionInterface): Promise<any> {
        return this.api.patch(`${path}/${props.idPosition}`, { ...props }, {})
            .then((res) => res)
    }
    static getPosition(idPosition: number): Promise<any> {
        return this.api.get(`${path}/${idPosition}`, {})
            .then((res) => res)
    }
}